import { useTableContext } from "../../../context/tableContext";
import { ClientConfirmation } from "../../molecules/generateScreen/clientConfirmation";
import { ClientForm } from "../../molecules/generateScreen/clientForm";
import styles from "./styles.module.scss";

export const ClientWindow = () => {
  const { clientFormData, setClientFormData } = useTableContext();
  return (
    <div className={`${styles.clientContainer}`}>
      <ClientForm
        clientFormData={clientFormData}
        setClientFormData={setClientFormData}
      />
      <ClientConfirmation clientFormData={clientFormData} />
    </div>
  );
};
